/* eslint-disable react/prop-types */
import React from 'react';

import { translate } from '~l10n/client';

import CloseX from 'CloseX';
import Constants from 'Constants';
import Input from 'Input';

export default class AddRoomView extends React.Component {
  componentDidMount() {
    let nameInput = document.getElementById('roomName');

    if (nameInput) {
      nameInput.focus();
    }
  }

  render() {
    let c = this.props.controller;
    let m = this.props.model;

    return (
      <div id="add-room-modal-background" className="modal open">
        <div id="add-room-modal-box" className="modal-dialog">
          <div className="modal-header">
            <span className="popup-title">{translate('Add Room')}</span>
            <div className="cancel-button" onClick={c.cancelClicked}>
              <CloseX className="cancel-button-x" color="#cccccc" />
            </div>
          </div>
          <div id="add-room-modal-content" className="form">
            <Input
              id="roomName"
              label={translate('Room Name')}
              maxLength={Constants.MAX_ROOM_NAME_LENGTH}
              status={m.nameStatus}
              tooltipLocation="above"
              value={m.name}
              onChange={(event) => c.nameChanged(event.target.value)}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  c.addClicked();
                }
              }}
            />
            <div className="add-room-buttons-container">
              <button
                id="addRoomButton"
                className="add-room-button"
                onClick={c.addClicked}
              >
                {translate('Add')}
              </button>
              <button
                className="add-room-button add-room-cancel-button"
                onClick={c.cancelClicked}
              >
                {translate('Cancel')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
